<template>
    <div class="doc-section">
        <h1>Eliminar Ubicación</h1>
        <p>
            Esta funcionalidad permite remover de forma definitiva un punto de interés previamente guardado en el
            sistema.
        </p>

        <plataformaNavegacion @cambio-plataforma="actualizarVista" />

        <h2>Pasos para la Eliminación</h2>
        <p>
            Para eliminar una ubicación, localice el registro en la tabla de ubicaciones guardadas y realice lo
            siguiente:
        </p>

        <ol class="ul-contenedor step-list">
            <li>Hacer clic sobre el botón <strong>Eliminar</strong> (representado con el icono de bote de basura) en la
                fila de la ubicación que desea remover.</li>
            <li>Se mostrará una ventana emergente de confirmación con el texto: <em>¿Está seguro que desea eliminar la
                    ubicación?</em>.</li>
            <li>Seleccione una de las siguientes opciones:
                <ul class="ul-contenedor step-list">
                    <li><strong>Botón Aceptar:</strong> Confirma la acción y elimina el registro permanentemente.
                    </li>
                    <li><strong>Botón Cancelar:</strong> Rechaza la acción y cierra la ventana emergente sin realizar
                        cambios.</li>
                </ul>
            </li>
        </ol>

        <div class="info-card">
            <p>
                <strong>Confirmación:</strong> Al eliminar la ubicación, el sistema mostrará una notificación en la
                parte superior indicando que el registro fue eliminado exitosamente.
            </p>
        </div>

        <h3>Referencia Visual</h3>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="imagenesEliminarUbicacion" />
        </div>
        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="imagenesEliminarUbicacionMoviles" />
        </div>
    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'EliminarUbicacion',
    components: { CarruselAciqui, plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenesEliminarUbicacion: [
            {
                nombre: "Confirmar Eliminado",
                url: "img/ubicaciones/EliminarUbicacion.png",
                descripcion: "Ventana emergente de confirmación para eliminar el registro."
            },
            {
                nombre: "Mensaje de Éxito",
                url: "img/ubicaciones/exitoEliminarUbicacion.png",
                descripcion: "Notificación visual tras la eliminación exitosa."
            }
        ],
        imagenesEliminarUbicacionMoviles: [
            {
                nombre: "Confirmar Eliminado",
                url: "img/ubicaciones/moviles/EliminarUbicacion.png",
                descripcion: "Ventana emergente de confirmación para eliminar el registro."
            },
            {
                nombre: "Mensaje de Éxito",
                url: "img/ubicaciones/exitoEliminarUbicacion.png",
                descripcion: "Notificación visual tras la eliminación exitosa."
            }
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>